import { getUrl } from '@/utils/getUrl';
import { http } from '@/utils/http';
import { NextApiRequest } from 'next';

export interface GetMyDataProps {
  articleId?: string;
  req?: NextApiRequest;
}

export const getSavedArticlesIds = () => http.get('/api/user/get-saved-articles');

const toggleArticle =(action: 'save' | 'remove', props?: GetMyDataProps) => {
  const articleId = props?.articleId;

  if (!articleId) {
    return;
  }

  const url = getUrl('/api/user/toggle-article')?.href;

  if (!url) {
    return;
  }

  return http.post(url, { articleId, action });
};

export const saveArticle = (props?: GetMyDataProps) => toggleArticle('save', props);

export const removeSavedArticle = (props?: GetMyDataProps) => toggleArticle('remove', props);
